<template>
  <div class="row">
    <div
      v-if="previousStepUrl"
      class="col-xs-12 col-md-6"
    >
      <a
        :href="previousStepUrl"
        class="button add-to-cart__button add-to-cart__button--previous"
        @click="handlePreviousBtnClick"
      >
        Previous Step
      </a>
    </div>
    <div :class="nextBtnColumnClasses">
      <button
        type="submit"
        class="button add-to-cart__button js-add-to-cart"
        @click="handleNextBtnClick"
      >
        {{ buttonText }}
      </button>
      <input
        v-if="letterJacketSteps !== null && letterJacketSteps.OrderPackageId !== null"
        :value="letterJacketSteps.OrderPackageId"
        name="OrderPackageId"
        type="hidden"
      >
    </div>
  </div>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'AddToCartButton',
  computed: {
    letterJacketSteps () {
      return this.$store.state.letterJackets.letterJacketContent.steps
    },
    isFirstStep () {
      if (this.letterJacketSteps === null) {
        return false
      }

      return this.letterJacketSteps.CurrentStep === 1
    },
    isLastStep () {
      if (this.letterJacketSteps === null) {
        return true
      }

      return this.letterJacketSteps.CurrentStep === this.letterJacketSteps.NumberSteps
    },
    buttonText () {
      if (this.isLastStep) {
        return 'Complete'
      }

      return 'Next Step'
    },
    previousStepUrl () {
      if (this.letterJacketSteps === null || this.isFirstStep) {
        return null
      }

      const previousStepIndex = this.letterJacketSteps.CurrentStep - 2 // CurrentStep is 1 based index, so to get the previous step index, need to substract 2 (-1 to get to a  zero-based, and another -1 for the previous step)
      const previousOfferPackageId = this.letterJacketSteps.OfferPackageIds[previousStepIndex]
      const previousOrderPackageId = this.letterJacketSteps.OrderPackageIds[previousStepIndex]

      return `${window.pageData.siteRoot}Catalog/Package/${previousOfferPackageId}?lastName=${this.customerInfo.LastName}&pin=${this.customerInfo.CustomerRef}&frameId=-1&orderPackageId=${previousOrderPackageId}`
    },
    nextBtnColumnClasses () {
      return {
        'col-xs-12': true,
        'col-md-6': true,
        'col-md-offset-3': this.previousStepUrl === null
      }
    },
    customerInfo () {
      return this.$store.state.catalogPageCommon.customerInfo
    }
  },
  methods: {
    handlePreviousBtnClick () {

    },
    handleNextBtnClick () {
      if (this.letterJacketSteps === null) {
        GoogleAnalytics.trackEvent(
          'Complete CTA',
          'click'
        )
      } else {
        if (this.isLastStep) {
          GoogleAnalytics.trackEvent(
            'Complete CTA',
            'click',
            this.letterJacketSteps.CurrentStep
          )
        } else {
          GoogleAnalytics.trackEvent(
            'Next Step CTA',
            'click',
            this.letterJacketSteps.CurrentStep
          )
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-to-cart {
  &__button {
    border-radius: 4px;
    display: block;
    font-size: 16px;
    font-weight: normal;
    margin: 0;
    padding: 0;
    text-align: center;
    width: 100%;

    &--previous {
      background-color: white;
      border: 2px solid $letterjacket-color-blue;
      color: $letterjacket-color-blue;
      line-height: 46px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/AddToCartButton.vue